import { Country } from './country';
import { FundsSourceType } from './funds-source';

export interface TierOneRequiredDocument {
    name: string;
    type: TierOneDocumentType;
    isRequired: boolean;
    isDocumentNumberNeeded: boolean;
    isExpirationDateNeeded: boolean;
    isBackSideNeeded: boolean;
}
export interface TierOneRequiredDocuments { [key: string]: TierOneRequiredDocument; }

export interface TierOneStatus {
    request: TierOneRequest;
    canTemporarilySkip: boolean;
    skipped: boolean;
    temporarilySkippedUntil: boolean;
}

export interface TierOneRequest {
    status: TierOneStatusType;
    statusDescription: string;
    analysisErrors: VerificationAnalysisErrors;
    dateOfLastChange: string;
    nationality: Country;
    secondaryNationality: Country;
    address: VerificationAddress;
    // Deprecated
    // fundsSource: FundsSource;
    fundsSourceType: FundsSourceType;
    otherFundsSource: string;
    termsAndConditionsAgreement: boolean;
    uploadedDocuments: TierOneDocument[];
}

export interface TierOneRequestInput {
    nationalityId?: string;
    secondaryNationalityId?: string;
    address?: {
        addressLine1?: string;
        city?: string;
        area?: string;
        countryId?: string;
    };
    // Deprecated
    // fundsSource?: FundsSource;
    fundsSourceId: string;
    otherFundsSource?: string;
    attachmentData?: TierOneDocumentData[];
    termsAndConditionsAgreement?: boolean;
    draft: boolean;
}

export interface TierOneDocument {
    id: string;
    type: TierOneDocumentType;
    name: string;
    mimeType: string;
    backSide: boolean;
    data: TierOneDocumentData;
    isContentUploaded: boolean;
}

export interface TierOneDocumentData {
    type?: TierOneDocumentType;
    documentNumber?: string;
    expirationDate?: string;
}

export interface VerificationAddress {
    addressLine1?: string;
    city?: string;
    area?: string;
    country?: Country;
    zip?: string;
}

export interface VerificationAnalysisErrors {
    identifier: string;
    title: string;
    message: string;
}

export enum TierOneStatusType {
    APPROVED = 'APPROVED',
    ERROR = 'ERROR',
    IN_PROGRESS = 'IN_PROGRESS',
    MANUAL_REVIEW = 'MANUAL_REVIEW',
    DISABLED_COUNTRY = 'DISABLED_COUNTRY',
    KYC_ISSUE = 'KYC_ISSUE',
    REJECTED = 'REJECTED',
    FORCE_APPROVED = 'FORCE_APPROVED',
    DUPLICATE_DOCUMENT = 'DUPLICATE_DOCUMENT',
    INVALID_DOCUMENT_UPLOADED = 'INVALID_DOCUMENT_UPLOADED',
    DUPLICATE_PERSON = 'DUPLICATE_PERSON',
    AGE_RESTRICTION = 'AGE_RESTRICTION',
    BAD_QUALITY_DOCUMENT_UPLOADED = 'BAD_QUALITY_DOCUMENT_UPLOADED',
    PENDING_DOCUMENTS = 'PENDING_DOCUMENTS',
    DRAFT = 'DRAFT'
}

export enum TierOneStatusGroup {
    EMPTY = 'EMPTY',
    DRAFT = 'DRAFT',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING_DOCUMENTS = 'PENDING_DOCUMENTS'
}

export enum TierOneDocumentType {
    IDENTITY_CARD = 'IDENTITY_CARD',
    PASSPORT = 'PASSPORT',
    DRIVING_LICENCE = 'DRIVING_LICENCE',
    PASSPORT_OR_DRIVING_LICENCE = 'PASSPORT_OR_DRIVING_LICENCE',
    WORK_PERMIT = 'WORK_PERMIT',
    PERSONAL_PHOTO = 'PERSONAL_PHOTO',
    IDENTITY_CARD_OR_PASSPORT = 'IDENTITY_CARD_OR_PASSPORT'
}

export function getTierOneStatusGroup(status: TierOneStatusType) {
    switch (status) {
        case TierOneStatusType.DRAFT:
        case TierOneStatusType.INVALID_DOCUMENT_UPLOADED:
        case TierOneStatusType.BAD_QUALITY_DOCUMENT_UPLOADED:
            return TierOneStatusGroup.DRAFT;
        case TierOneStatusType.APPROVED:
        case TierOneStatusType.FORCE_APPROVED:
            return TierOneStatusGroup.SUCCESS;
        case TierOneStatusType.IN_PROGRESS:
            return TierOneStatusGroup.IN_PROGRESS;
        case TierOneStatusType.MANUAL_REVIEW:
            return TierOneStatusGroup.PENDING;
        case TierOneStatusType.PENDING_DOCUMENTS:
            return TierOneStatusGroup.PENDING_DOCUMENTS;
        case TierOneStatusType.ERROR:
        case TierOneStatusType.DISABLED_COUNTRY:
        case TierOneStatusType.KYC_ISSUE:
        case TierOneStatusType.REJECTED:
        case TierOneStatusType.DUPLICATE_DOCUMENT:
        case TierOneStatusType.DUPLICATE_PERSON:
        case TierOneStatusType.AGE_RESTRICTION:
            return TierOneStatusGroup.ERROR;
        default:
            return TierOneStatusGroup.EMPTY;
    }
}
